export function stripTypename({ __typename, ...rest }) {
    return rest
}
